import { render, staticRenderFns } from "./EqifyListAvatar.vue?vue&type=template&id=741b9954&scoped=true"
import script from "./EqifyListAvatar.vue?vue&type=script&lang=ts"
export * from "./EqifyListAvatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741b9954",
  null
  
)

export default component.exports